<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title">
          <h1>나의 검색이력</h1>
        </div>
        <section>
          <div class="row4">
            <div class="topContent flex searchHistoryCon mobileReset">
              <div class="left flex">
                <p>
                  총 <span>{{ productCount + serviceCount }}</span
                  >건
                </p>
                <div class="tops">
                  <div class="tabMenu secItemMG">
                    <button
                      class="accountTabBtn"
                      :class="{ active: currentTab === 0 }"
                      v-on:click="setTabChange(0, 'PRODUCT')"
                    >
                      제품 <span> {{ productCount }} </span>
                    </button>
                    <button
                      class="accountTabBtn"
                      :class="{ active: currentTab === 1 }"
                      v-on:click="setTabChange(1, 'SERVICE')"
                    >
                      서비스 <span> {{ serviceCount }} </span>
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <input
                  type="text"
                  class="searchInput"
                  v-model="searchText"
                  @keyup.enter="searchDatas"
                />
                <input
                  type="button"
                  value="검 색"
                  class="searchBtn searchBtnCmmn"
                  @click="searchDatas"
                />
                <input
                  type="button"
                  value="검색초기화"
                  class="searchResetBtn searchBtnCmmn"
                  @click="resetSearch"
                />
              </div>
            </div>

            <div class="mobileBlock searchHistoryMobileCon">
              <div class="tops">
                <div class="tabMenu secItemMG">
                  <button
                    class="accountTabBtn"
                    :class="{ active: currentTab === 0 }"
                    v-on:click="setTabChange(0, 'PRODUCT')"
                  >
                    제품 <span> {{ productCount }} </span>
                  </button>
                  <button
                    class="accountTabBtn"
                    :class="{ active: currentTab === 1 }"
                    v-on:click="setTabChange(1, 'SERVICE')"
                  >
                    서비스 <span> {{ serviceCount }} </span>
                  </button>
                </div>
                <div class="historySearchBox">
                  <input
                    type="text"
                    class="searchInput"
                    v-model="searchText"
                    @keyup.enter="searchDatas"
                  />
                  <input
                    type="button"
                    value="검 색"
                    class="searchBtn searchBtnCmmn"
                    @click="searchDatas"
                  />
                </div>
              </div>
            </div>

            <div v-if="currentTab === 0" class="searchResultCon">
              <hr />
              <div class="searchResultBody">
                <router-link
                  :to="
                    '/productDetail/' +
                      product.CATEGORY_IDX +
                      '/' +
                      product.BOARD_IDX
                  "
                  v-for="(product, index) in items"
                  :key="index"
                >
                  <div class="searchResultItem">
                    <!-- 조회수 카운트 -->
                    <div class="likeCountBox">
                      <h5>
                        조회수
                        <span>
                          {{ product.VIEW_CNT }}
                        </span>
                      </h5>
                    </div>
                    <div class="imgBox">
                      <img :src="product.MAIN_FILE" alt="" />
                    </div>
                    <div class="title">
                      <p>
                        {{ product.CATEGORY_NAME }}
                      </p>
                    </div>
                    <div class="subContent">
                      <table>
                        <tbody>
                          <tr>
                            <th>제조 구분</th>
                            <td>{{ product.MANUFACTURE_STR }}</td>
                          </tr>
                          <tr>
                            <th>업체명</th>
                            <td>{{ product.COMPANY }}</td>
                          </tr>
                          <tr>
                            <th>제품명</th>
                            <td>{{ product.NAME }}</td>
                          </tr>
                          <tr>
                            <th>사용제안공간</th>
                            <td>
                              <p>
                                {{ product.PLACE_NAME }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </router-link>
                <!-- 검색 결과 아이템 div 끝 -->
              </div>
            </div>
            <div v-else class="searchResultCon">
              <hr />
              <div class="searchResultBody">
                <router-link
                  :to="
                    '/serviceDetail/' +
                      service.CATEGORY_IDX +
                      '/' +
                      service.BOARD_IDX
                  "
                  v-for="(service, index) in items"
                  :key="index"
                >
                  <div class="searchResultItem">
                    <!-- 조회수 카운트 -->
                    <div class="likeCountBox">
                      <h5>
                        조회수
                        <span>
                          {{ service.VIEW_CNT }}
                        </span>
                      </h5>
                    </div>
                    <div class="imgBox">
                      <img :src="service.MAIN_FILE" alt="" />
                    </div>
                    <div class="title">
                      <p>
                        {{ service.NAME }}
                      </p>
                    </div>
                    <div class="subContent">
                      <table>
                        <tbody>
                          <tr>
                            <th>생활 구분</th>
                            <td>{{ service.CATEGORY_NAME }}</td>
                          </tr>
                          <tr>
                            <th>업체명</th>
                            <td>{{ service.COMPANY }}</td>
                          </tr>
                          <tr>
                            <th>서비스명</th>
                            <td>{{ service.NAME }}</td>
                          </tr>
                          <tr>
                            <th>사용제안대상</th>
                            <td>
                              <p>
                                {{ service.TARGET }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="tableContainer">
              <div class="sampleTemplate">
                <paginate
                  :page-count="navCnt"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'‹'"
                  :next-text="'›'"
                  :container-class="'pagination b-pagination newPagination'"
                >
                </paginate>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "@/axios/axios";

export default {
  name: "SearchHistory",
  components: {},
  data() {
    return {
      currentTab: 0,
      productCount: 0,
      serviceCount: 0,
      type: "PRODUCT",
      items: null,
      searchText: this.$route.query.searchText
        ? this.$route.query.searchText
        : "",
      perPage: 9,
      currentPage: 1,
      totalCnt: 0,
      sortBy: "UPDATE_DATE",
      sortDesc: false,
    };
  },
  mounted() {
    this.getDatas();
  },
  computed: {
    navCnt: function() {
      if (this.totalCnt % this.perPage == 0)
        return this.totalCnt / this.perPage;
      else return Math.floor(this.totalCnt / this.perPage) + 1;
    },
  },
  methods: {
    setTabChange(currentTab, type) {
      this.currentTab = currentTab;
      this.type = type;

      this.getDatas();
    },
    getDatas() {
      axios
        .post("/api/user/searchHistory/getList", null, {
          params: {
            searchText: this.searchText,
            currentPage: this.currentPage,
            perPage: this.perPage,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
            type: this.type,
          },
        })
        .then((response) => {
          this.items = response.data.items;
          this.totalCnt = response.data.totalCnt;
          this.productCount = response.data.productCount;
          this.serviceCount = response.data.serviceCount;
        })
        .catch((error) => {
          console.log("error: " + error);
          return [];
        });
    },
    searchDatas() {
      let path = `/user/searchHistory?searchText=${this.searchText}`;
      if (this.$route.fullPath !== path) {
        this.$router.push({
          path: "/user/searchHistory",
          query: { searchText: this.searchText },
        });
      }

      this.getDatas();
    },
    resetSearch() {
      this.searchText = "";
      let path = `/user/searchHistory`;
      if (this.$route.fullPath !== path) {
        this.$router.push({ path: "/user/searchHistory" });
      }

      this.getDatas();
    },
    clickCallback(pageNum) {
      this.currentPage = pageNum;
      this.getDatas();
    },
  },
};
</script>

<style scoped>
.secItemMG button {
  min-width: 133px;
}
.secItemMG button:nth-of-type(2) {
  margin: 0 0 0 10px;
}
</style>

<style scoped lang="scss">
.bspRadio ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
.bspSelectBox ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>
